import registerReducer from './reducers'

export { default as registerActions } from './actions'
export { default as registerSagas } from './sagas'

export default registerReducer